import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Col, Row, Skeleton } from "antd";
import moment from "moment";
import './subscriptions.scss';
import ActiveSubscriptions from "./ActiveSubscriptions";
import PurchaseHistory from "./PurchaseHistory";
//model
import { Students } from "../../../../models/StudentsModel/students.model";
import { Subscription } from "../../../../models/SubscriptionModel/subscription.model";
//service
import { SubscriptionsService } from "../../../../services/SubscriptionService/subscription.service";

const StudentSubscriptions = () => {
    const { state }: { state: Students } = useLocation();
    const [subscriptionsData, setSubscriptionsData] = useState<Subscription[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    const fetchSubscriptions = () => {
        if (state?.id) {
            setLoading(true)
            SubscriptionsService.fetchSubscriptions(
                state?.id,
                (data) => {
                    setSubscriptionsData(data);
                },
                () => { },
                () => {
                    setLoading(false);
                }
            );
        }
    };

    useEffect(() => {
        fetchSubscriptions();
    }, []);



    if (loading) {
        return (
            <div className="details__container">
                <Row gutter={16} className="details__wrapper">
                    <Col span={12}>
                        <Skeleton avatar paragraph={{ rows: 4 }} />
                    </Col>
                    <Col span={12}>
                        <Skeleton avatar paragraph={{ rows: 4 }} />
                    </Col>
                </Row>
                <Row gutter={16} className="details__wrapper">
                    <Col span={12}>
                        <Skeleton avatar paragraph={{ rows: 4 }} />
                    </Col>
                    <Col span={12}>
                        <Skeleton avatar paragraph={{ rows: 4 }} />
                    </Col>
                </Row>

            </div>)
    }
    
    return (
        <div className="subscription__container">
            <div className="details__wrapper">
                <ActiveSubscriptions
                    data={subscriptionsData.filter(data=>moment().isBefore(data.endDate,'day'))}
                />
            </div>
            <div className="details__wrapper">
                <PurchaseHistory
                    data={subscriptionsData.filter(data=>moment().isAfter(data.endDate,'day'))}
                />
            </div>
        </div>



    )
}

export default StudentSubscriptions;
